<template>
  <a-form v-if="result === 'none'" name="custom-validation" ref="formRef" :model="formState" :rules="rules" v-bind="layout" @finish="handleFinish" @finishFailed="handleFinishFailed">
    <a-form-item has-feedback :label="t('common.label.email')" name="email">
      <a-input v-model:value="formState.email" autocomplete="off" />
    </a-form-item>
    <a-form-item has-feedback :label="t('common.label.message')" name="message">
      <a-textarea :autoSize="{ minRows: 8, maxRows: 20 }" v-model:value="formState.message" />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" html-type="submit">{{ t("common.action.send") }}</a-button>
    </a-form-item>
  </a-form>
  <div v-else>
    <a-result :status="result" :title="resultTitle" :sub-title="resultSubtitle"></a-result>
  </div>
</template>
<script lang="ts">
type formState = "success" | "error" | "none";
import { RuleObject, ValidateErrorEntity } from "ant-design-vue/es/form/interface";
import { computed, defineComponent, reactive, ref, UnwrapRef, watch } from "vue";
import { useI18n } from "vue-i18n";
import { sendContactForm } from "../api/email";
import { ContactForm } from "../models/contact/Email";
import { useUserStore } from "../store/modules/user";
interface FormState {
  email: string;
  message: string;
}
export default defineComponent({
  name: "Login Form",
  setup() {
    const { t } = useI18n();
    const formRef = ref();
    const store = useUserStore();
    const result = ref<formState>("none");
    const resultTitle = ref("");
    const resultSubtitle = ref("");

    const formState: UnwrapRef<FormState> = reactive({
      email: "",
      message: "",
    });

    let validateEmail = async (rule: RuleObject, value: string) => {
      if (value === "") {
        return Promise.reject(t("validations.required"));
      } else {
        return Promise.resolve();
      }
    };

    const rules = {
      email: [{ validator: validateEmail, trigger: "submit" }],
    };
    const layout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    };
    const handleFinish = (values: FormState) => {
      const message: ContactForm = {
        id: 0,
        state: "created",
        type: "zco",
        client_email: formState.email,
        client_name: formState.email,
        description: formState.message,
        client_preferred_contact_type: "Per Email",
        compliance: true,
        client_phone: "",
      };
      sendContactForm(message)
        .then(() => {
          result.value = "success";
          resultTitle.value = t("contactpage.send.success.title");
          resultSubtitle.value = t("contactpage.send.success.subTitle");
        })
        .catch((error) => {
          result.value = "error";
          resultTitle.value = t("contactpage.send.error.title");
          resultSubtitle.value = t("contactpage.send.error.subTitle");
        });
    };
    formState.email = store.getProfile.username != null ? store.getProfile.username : " ";
    const handleFinishFailed = (errors: ValidateErrorEntity<FormState>) => {
      console.error("Unable to send email");
    };
    watch(
      () => store.getProfile.username,
      () => (formState.email = store.getProfile.username)
    );
    return {
      formState,
      formRef,
      rules,
      layout,
      handleFinishFailed,
      handleFinish,
      t,
      result,
      resultTitle,
      resultSubtitle,
    };
  },
});
</script>
